import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PublicShellStatus } from './public/PublicShell';

const ProtectedRoute = ({ children, skipTermsCheck = false }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <PublicShellStatus>
                <span className="pshell-spinner" aria-hidden="true" /> Loading…
            </PublicShellStatus>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check if user has accepted terms of service (unless skipTermsCheck is true)
    // TEMPORARILY DISABLED - uncomment to re-enable terms of service requirement
    // if (!skipTermsCheck && user && !user.accepted_terms_of_service) {
    //     // Don't redirect if already on the TOS page
    //     if (location.pathname !== '/terms-of-service') {
    //         return <Navigate to="/terms-of-service" replace />;
    //     }
    // }

    return children;
};

export default ProtectedRoute;
